module.exports = __webpack_public_path__ + "static/media/warn-icon.58ca697f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/warn-icon.svg
// module id = 7611
// module chunks = 0